import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import App from './App';
import { msalInstance } from './auth/msalConfig';
import './styles/globals.scss';

msalInstance.initialize().then(() => {
  // Handle post-login redirect
  msalInstance.handleRedirectPromise().then((response) => {
    if (response && sessionStorage.getItem('postLoginRedirect')) {
      const redirectPath = sessionStorage.getItem('postLoginRedirect');
      sessionStorage.removeItem('postLoginRedirect');

      // Validate redirect path to prevent open redirect vulnerability
      if (redirectPath && redirectPath.startsWith('/') && !redirectPath.startsWith('//')) {
        window.location.href = redirectPath;
      } else {
        // Default to home page if invalid redirect
        window.location.href = '/';
      }
    }
  });

  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
});
